export type Student = { starId: string; techId: string; displayName: string };
export type ImpersonationMode = 'View' | 'Edit';
export type StudentAccess = { undergraduateAccess: boolean; certAccess: boolean; graduateAccess: boolean };
export type ImpersonationSession = { sessionId: string; student: Student; expiresOnUtc: string; mode?: ImpersonationMode; kind?: 'Student' | 'Evaluator' | 'Viewer' | 'GraduateEvaluator' | 'GraduateFaculty'; access?: StudentAccess };
export type ImpersonationState = { handle: string; session: ImpersonationSession };
const key = 'graduationImpersonation';
const listeners = new Set<() => void>();
let current: ImpersonationState | null = null;
// Server-start trust belongs to this page's memory, never persisted storage.
let started: ImpersonationState | null = null;
let invalidatedHandle: string | null = null;
try {
  const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
  if (saved?.handle && saved?.session?.student && saved?.session?.sessionId) current = saved;
} catch { sessionStorage.removeItem(key); }

const publish = (value: ImpersonationState | null, freshlyStarted = false) => {
  current = value;
  started = freshlyStarted ? value : null;
  invalidatedHandle = null;
  if (value) sessionStorage.setItem(key, JSON.stringify(value));
  else sessionStorage.removeItem(key);
  listeners.forEach(listener => listener());
};

export const ImpersonationStore = {
  get: () => current,
  subscribe: (listener: () => void) => { listeners.add(listener); return () => { listeners.delete(listener); }; },
  set: (value: ImpersonationState | null) => publish(value),
  setStarted: (value: ImpersonationState) => publish(value, true),
  isStarted: (value: ImpersonationState) => started === value && Date.parse(value.session.expiresOnUtc) > Date.now(),
  isInvalidated: (value: ImpersonationState) => invalidatedHandle === value.handle,
  invalidate: (handle: string) => {
    if (!current || current.handle !== handle || invalidatedHandle === handle) return;
    started = null;
    invalidatedHandle = handle;
    current = { ...current };
    listeners.forEach(listener => listener());
  },
};

